/*
 All the routes and corresponding breadcrumb text mapping will go here
*/
module.exports = {
  '/customer_support': I18n.translate('js.modules.web_2018.customer_support_crumb'),
  '/customer_support/web/orders': I18n.translate('js.modules.web_2018.orders_crumb'),
  '/customer_support/web/claims': I18n.translate('js.modules.web_2018.claims_crumb'),
  '/customer_support/web/order': I18n.translate('js.modules.web_2018.order_crumb'),
  '/customer_support/web/claim/summary': I18n.translate('js.modules.web_2018.claim_crumb'),
  '/customer_support/web/transactions': I18n.translate('js.modules.web_2018.transactions_crumb'),
  '/customer_support/web/contact_channels': I18n.translate('js.modules.web_2018.contact_us_crumb'),
  '/customer_support/web/gplus/contact_channels': I18n.translate('js.modules.web_2018.contact_us_crumb'),
  '/customer_support/web/refund_request': I18n.translate("js.modules.support.refund_request"),
  '/customer_support/web/faq/search': I18n.translate('js.modules.web_2018.search_results_crumb'),
  '/customer_support/web/summary/search': I18n.translate('js.modules.web_2018.search_results_crumb'),
  '/faq#faqs:content-': I18n.translate('js.modules.web_2018.articles_crumb'),
  '/faq#faqs:category-': I18n.translate('js.modules.web_2018.articles_crumb'),
  '/faq': I18n.translate('js.modules.web_2018.faq_crumb')
};
